import React, {useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import { InputLabel, Chip, Popover, Grid, Typography } from "@material-ui/core";
import { AddOutlined } from "@material-ui/icons";
import __ from "lodash";
import { Alert, ComboSelect, Form, MaskedNumber } from ".";
import MaskedText from "./MaskedText";

const formatChars={
  "x": "."
}

const UldEquipmentSelect = (props) => {

  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 300,
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    chipWithNoLabel: {
      margin: 2,
      '& .MuiChip-labelSmall': {
        paddingRight: 0,
      }
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
    menuPaper: {
      maxHeight: 500
    }
  }));

  const {id, label, readOnly, disabled, onChange, value: values, allowZero} = props;
  const [oldValues, setOldValues] = useState(values);
  const [valuesArray, setValuesArray] = useState(values || []);
  const [addEquipmentEl, setAddEquipmentEl] = React.useState(null);
  const showSelector = Boolean(addEquipmentEl);

  if (values !== oldValues) {
    setValuesArray(values);
    setOldValues(values);
  }

  const classNames = [props.className];
  if (props.readOnly) {
    classNames.push('readOnly');
  }

  const className = classNames.join(" ");
  const classes = useStyles();

  const handleAdd = (event) => {
    setAddEquipmentEl(event.currentTarget);
  };

  const handleDelete = ({value, position}) => {
    const values = [...valuesArray];
    values.splice(position,1);
    setValuesArray(values);
    if (onChange) {
      onChange({equipment: values});
    }
  }

  const handleSelectEquipment = (record) => {
    const equipment = __.pick(record,
      ['equipmentType', 'equipmentName', 'unitWeight', 'quantity']);
    const values = [...valuesArray, equipment];
    setAddEquipmentEl(null);
    setValuesArray(values);
    if (onChange) {
      onChange({equipment: values});
    }
  }

  const handleCloseSelector = () => {
    setAddEquipmentEl(null);
  };

  const Validator = (props) => {
    const record = props.record;
  
    const [state, setState] = useState({
      error: null,
      errorMessage: null
    }); 
  
    let error = false;
    let errorMessage = "";
  
    if (!error && !record.equipmentType) {
      error = true;
      errorMessage = "'Equipment Type' is required";
    }
    if (!error && (isNaN(record.quantity) || record.quantity < (allowZero?0:1) || record.quantity > 9999)) {
      error = true;
      errorMessage = "A valid 'Quantity' is required";
    }
    if (record.equipmentType === "OTHER") {
      if (!error && __.isEmpty(record.equipmentName)) {
        error = true;
        errorMessage = "A valid 'Equipment Name' is required";
      }
      if (!error && (!record.unitWeight || isNaN(record.unitWeight || record.unitWeight < 1 || record.unitWeight > 9999))) {
        error = true;
        errorMessage = "A valid 'Unit Weight' is required";
      }
    }  
    if (error !== state.error || errorMessage !== state.errorMessage) {
      setState({ ...state, error, errorMessage });
      if (props.onChange) {        
        props.onChange({ error, errorMessage });
      }
    }
  
    return (
      <Alert open={error} severity="error" message={errorMessage}/>
    );
  }

  return (
    <div className={className}>
      {label?
        <InputLabel shrink id={`${id}-label`} style={{position: "relative", marginBottom: 0}} >{label}</InputLabel>
        :<></>
      }
      <div className={classes.chips} style={{...props.chipsStyle}}>
        {valuesArray.map((record, i) => (
          <Chip
            key={i}
            label={`${record.quantity} x ${record.equipmentName || record.equipmentType}`}
            className={classes.chip}
            style={{...props.chipStyle}}
            size={"small"}
            onDelete={readOnly||disabled?null:()=>handleDelete({record, position: i})}
          />
        ))}
        {readOnly||disabled?<></>:
        <Chip
          key={'add'}
          color="primary"
          icon={<AddOutlined/>}
          className={classes.chipWithNoLabel}
          style={{...props.chipStyle}}
          size={"small"}
          onClick={(e)=>handleAdd(e)}
        />}
        {readOnly||disabled?<></>:
          <Popover
            id={id}
            open={showSelector}
            anchorEl={addEquipmentEl}
            onClose={handleCloseSelector}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <Form key="form"
              open={true}
              record={{equipmentType: null, equipmentName: null, unitWeight: 0, quantity: 0}}
              validator={Validator}
              validatorPosition="bottom"
              validatorStyle={{padding: 0}}
              formBodyStyle={{maxHeight: "calc(100vh - 320px)"}}
              buttonBarStyleOverride={{position: "relative", width: "calc(100% - 30px)", marginTop: -30}}
              buttons = {
                {
                  save:{icon: "check_circle", key: "Add", label: "Add", color: "primary", disabled: (status)=>{return status.error}}, 
                  cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
                }
              }
            
              onChange={(state) => {
                if (state.buttonPressed === "cancel") {
                  handleCloseSelector()
                }
                if (state.buttonPressed === "save") {
                  const record = state.record;
                  handleSelectEquipment(record);
                }
              }}
            >
              <div style={{paddingBottom: 10}}>
                <div style={{padding: "10px 0px"}}>
                  <Typography sx={{ p: 2 }}>Please select a type and quantity</Typography>
                </div>
                <Grid container checkChildren={true} spacing={1}>
                  <Grid item xs={8} checkChildren={true}>
                    <ComboSelect 
                      id="equipmentType"
                      label="Equipment Type"
                      group='ULD EQUIPMENT'
                      returnType="objectOnly"
                      inputLabelProps={{shrink: true}}
                      style={{maxWidth: 200, width: 200}}
                      onChange={(combo, props) => {
                        const {record, recordChange} = props;
                        recordChange({...record, equipmentType: combo.code, equipmentName: combo.value, unitWeight: combo?.data?.weight || 0})
                      }}
                    />
                  </Grid>    
                  <Grid item xs={4} checkChildren={true}>
                    <MaskedNumber 
                      id="quantity"
                      label="Quantity"
                      inputLabelProps={{shrink: true}}
                      decimalScale={0}
                      fixedDecimalScale={true}
                      fullWidth={true}
                    />
                  </Grid>    
                </Grid>
                {(record)=> {
                  if (!record || record.equipmentType !== "OTHER") return null;
                  return (
                    <Grid container checkChildren={true} spacing={1}>
                      <Grid item xs={8} checkChildren={true}>
                        <MaskedText 
                          id="equipmentName"
                          label="Equipment Name"
                          mask={'x'.repeat(50)}
                          maskChar={""}
                          formatChars={formatChars}
                          forceSentenceCase={true}
                          style={{width: 200, maxWidth: 200}}
                        />
                      </Grid>    
                      <Grid item xs={4} checkChildren={true}>
                        <MaskedNumber 
                          id="unitWeight"
                          label="Unit Weight"
                          inputLabelProps={{shrink: true}}
                          decimalScale={1}
                          fixedDecimalScale={true}
                          allowNegative={false}
                          valueCap={9999}
                          fullWidth={true}
                        />
                      </Grid>  
                    </Grid>
                  )
                }}  
              </div>
            </Form>
          </Popover>
        }
      </div>
    </div>
  );
}

export default UldEquipmentSelect;
